import { useState } from "react";
import Thyroid_ultra_sound from "../../../../Forms/applications/thyroidUltraSound";
import ObdominalUltrasoundModal from "../../../../Forms/applications/abdominalultrasound";
import AbdominalDopplerModal from "../../../../Forms/applications/abdominalDoppler";
import AortaUltraSound from "../../../../Forms/applications/aortaUltraSound";
import BladderUltraSound from "../../../../Forms/applications/bladderultrasound";
import BreastUltraSound from "../../../../Forms/applications/breastultrasound";
import RenelDoplerUltraSound from "../../../../Forms/applications/renaldoppler";
import LowerExtremelyVennousDoppler from "../../../../Forms/applications/lowerExtremelyVenous";
import TestucularUltraSound from "../../../../Forms/applications/testicularultrasound";
import ProstateTransAbdorminal from "../../../../Forms/applications/prostateTransAbdorminal";
import OrthoultraSound from "../../../../Forms/applications/orthoultrasound";
import Estim from "../../../../Forms/applications/estim";
import PelvicUltrasoundForm from "../../../../Forms/applications/PelvicUltrasound";

const Imaging = ({ data }) => {
  const [thyroidModal, setThyroidModal] = useState(false);
  const [abdominalModal, setAbdominalModal] = useState(false);
  const [dopplerModal, setDopplerModal] = useState(false);
  const [aortaSoundModal, setAortaSoundModal] = useState(false);
const [bladderultrasoundmodal,setBladderUltrasoundModal]=useState(false)
const [breastultrasoundmodal,setBreastUltrasoundModal]=useState(false)
const [RenalDoplerModal,setRenalDoplerModal]=useState(false)
const [lowerextremelyvenousdopplerModal,setLowerExtremelyVenousDopplerModal]=useState(false)
const [testicularultrasoundmodal,setTesticularUltrasoundmodal]=useState(false)
const [ProstateTransAbdorminalmodal,setProstateTransAbdorminalModal]=useState(false)
const [OrthoultraSoundModal,setOrthoUltraSound1modal]=useState(false)
const [PelvicUltrasoundModal,setPelvicUltraSoundModal]=useState(false)
const [EstimModal,setEstimModal]=useState(false)

const forms=[
            "THYROID ULTRASOUND",
            "ABDOMINAL ULTRASOUND",
            "ABDOMINAL ULTRASOUND DOPPLER",
            "AORTA ULTRASOUND",
            'BLADDER ULTRASOUND PRELIMINARY',
            'BREAST ULTRASOUND',
            'RENAL DOPPLER ULTRASOUND',
            'LOWER EXTREMELY VENOUS DOPPLER',
            'TESTICULAR ULTRASOUND',
            'PROSTATE TRANSABDOMINAL IMAGING',
            'ORTHO ULTRASOUND',
            'ESTIM'
          ]
          if (data.gender === 'F') {
  forms.splice(2, 0, "PELVIC ULTRASOUND"); // insert at index 2 (or any specific index)
    const testicularIndex = forms.indexOf("TESTICULAR ULTRASOUND");
  if (testicularIndex !== -1) {
    forms.splice(testicularIndex, 1);
  }
}
  const openModal = (type) => {
    switch (type) {
      case "THYROID ULTRASOUND":
        setThyroidModal(true);
        break;
      case "ABDOMINAL ULTRASOUND":
        setAbdominalModal(true);
        break;
      case "ABDOMINAL ULTRASOUND DOPPLER":
        setDopplerModal(true);
        break;
      case "AORTA ULTRASOUND":
        setAortaSoundModal(true);
        break;
      case 'BLADDER ULTRASOUND PRELIMINARY':
         setBladderUltrasoundModal(true)
         break;
      case 'BREAST ULTRASOUND':
        setBreastUltrasoundModal(true)
        break;
      case 'RENAL DOPPLER ULTRASOUND':
        setRenalDoplerModal(true)
        break;
      case 'LOWER EXTREMELY VENOUS DOPPLER' :
      setLowerExtremelyVenousDopplerModal(true)
       break;
       case 'TESTICULAR ULTRASOUND':
        setTesticularUltrasoundmodal(true)
        break;
      case 'PROSTATE TRANSABDOMINAL IMAGING':
        setProstateTransAbdorminalModal(true)
        break;
        case 'ORTHO ULTRASOUND':
          setOrthoUltraSound1modal(true)
          break;
        case 'ESTIM' :
      setEstimModal(true)
      break;
case 'PELVIC ULTRASOUND' :
      setPelvicUltraSoundModal(true)
      break;
        default:
        break;
    }
  };


  return (
    <div className="w-full p-4">
      <div className="w-full min-h-[200px] rounded-[16px] border border-[#F3F4F6] bg-white/50 shadow-[0_20px_25px_-5px_rgba(0,0,0,0.1),_0_8px_10px_-6px_rgba(0,0,0,0.1)] backdrop-blur-sm p-6">
        <h2 className="text-[24px] text-start font-semibold text-[#111827]">
          Select Type of Worksheet
        </h2>
        <p className="text-sm text-start text-[#6B7280] mt-1 mb-4">
          Choose the appropriate worksheet type to continue
        </p>
       

        <div className="grid grid-cols-2 sm:grid-cols-2 gap-3">
          {forms.map((type) => (
            <button
              key={type}
              onClick={() => openModal(type)}
              className="text-[#E17954] text-center text-sm px-3 py-3 rounded-[12px] bg-gradient-to-r from-[#E179540D] to-[#E179541A] shadow-sm"
            >
              {type}
            </button>
          ))}
        </div>
      </div>

  {thyroidModal ? (
  <Thyroid_ultra_sound
    data={data}
    ismodal={thyroidModal}
    setIsmodal={setThyroidModal}
  />
) : <></>}

{abdominalModal ? (
  <ObdominalUltrasoundModal
    data={data}
    ismodal={abdominalModal}
    setIsmodal={setAbdominalModal}
  />
) : <></>}

{dopplerModal ? (
  <AbdominalDopplerModal
    data={data}
    ismodal={dopplerModal}
    setIsmodal={setDopplerModal}
  />
) : <></>}

{aortaSoundModal ? (
  <AortaUltraSound
    data={data}
    ismodal={aortaSoundModal}
    setIsmodal={setAortaSoundModal}
  />
) : <></>}

{bladderultrasoundmodal ? (
  <BladderUltraSound
    data={data}
    ismodal={bladderultrasoundmodal}
    setIsmodal={setBladderUltrasoundModal}
  />
) : <></>}

{breastultrasoundmodal ? (
  <BreastUltraSound
    data={data}
    ismodal={breastultrasoundmodal}
    setIsmodal={setBreastUltrasoundModal}
  />
) : <></>}

{RenalDoplerModal ? (
  <RenelDoplerUltraSound
    data={data}
    ismodal={RenalDoplerModal}
    setIsmodal={setRenalDoplerModal}
  />
) : <></>}

{lowerextremelyvenousdopplerModal ? (
  <LowerExtremelyVennousDoppler  
    data={data}
    ismodal={lowerextremelyvenousdopplerModal}
    setIsmodal={setLowerExtremelyVenousDopplerModal}
  />
) : <></>}

{testicularultrasoundmodal ? (
  <TestucularUltraSound  
    data={data}
    ismodal={testicularultrasoundmodal}
    setIsmodal={setTesticularUltrasoundmodal}
  />
) : <></>}

{ProstateTransAbdorminalmodal ? (
  <ProstateTransAbdorminal  
    data={data}
    ismodal={ProstateTransAbdorminalmodal}
    setIsmodal={setProstateTransAbdorminalModal}
  />
) : <></>}

{OrthoultraSoundModal ? (
  <OrthoultraSound 
    data={data}
    ismodal={OrthoultraSoundModal}
    setIsmodal={setOrthoUltraSound1modal}
  />
) : <></>}

{EstimModal ? (
  <Estim 
    data={data}
    ismodal={EstimModal}
    setIsmodal={setEstimModal}
  />
) : <></>}

{PelvicUltrasoundModal ? (
  <PelvicUltrasoundForm 
    data={data}
    ismodal={PelvicUltrasoundModal}
    setIsmodal={setPelvicUltraSoundModal}
  />
) : <></>}

    </div>
  );
};

export default Imaging;
